// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';

// const ProductDetail = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [product, setProduct] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedImage, setSelectedImage] = useState(0);
//   const [quantity, setQuantity] = useState(1);
//   const [showOptions, setShowOptions] = useState(false);

//   const API_BASE_URL = 'http://localhost:5000/api';

//   // WhatsApp number
//   const WHATSAPP_NUMBER = '8421377814';

//   // Static fallback data
//   const productData = [
//     {
//       id: 1,
//       name: "SolarSquare Flexi 300W Panel",
//       description: "High-efficiency monocrystalline solar panel with 21.5% efficiency",
//       fullDescription: "Premium monocrystalline solar panel with anti-reflective coating, superior low-light performance, and 25-year linear power output warranty. Perfect for residential rooftops. Features advanced PERC technology for higher efficiency and better performance in low-light conditions.",
//       price: 18500,
//       originalPrice: 21500,
//       category: "panels",
//       rating: 4.8,
//       reviews: 124,
//       image: "/products/solar-panel-1.jpg",
//       images: [
//         "/products/solar-panel-1.jpg",
//         "/products/solar-panel-2.jpg",
//         "/products/solar-panel-3.jpg"
//       ],
//       features: ["300W Output", "25-year Warranty", "Weather Resistant", "Easy Installation", "High Efficiency", "PERC Technology", "Anti-reflective Coating"],
//       tags: ["best-seller", "new-arrival", "featured"],
//       stock: 25,
//       isFeatured: true,
//       specs: { 
//         power: "300W", 
//         efficiency: "21.5%", 
//         warranty: "25 years", 
//         dimensions: "175×100 cm", 
//         weight: "18 kg",
//         cellType: "Monocrystalline",
//         operatingTemp: "-40°C to +85°C",
//         maxVoltage: "1000V"
//       },
//     },
//     {
//       id: 2,
//       name: "SmartSolar Inverter 5kW",
//       description: "Hybrid solar inverter with battery backup",
//       fullDescription: "Smart hybrid inverter with WiFi monitoring, pure sine wave output, and seamless grid-tie functionality. Includes mobile app for real-time monitoring. Features MPPT technology for maximum energy harvest and supports both grid-tie and off-grid operations.",
//       price: 45000,
//       originalPrice: 52000,
//       category: "inverters",
//       rating: 4.7,
//       reviews: 89,
//       image: "/products/inverter-1.jpg",
//       images: [
//         "/products/inverter-1.jpg",
//         "/products/inverter-2.jpg",
//         "/products/inverter-3.jpg"
//       ],
//       features: ["5kW Capacity", "WiFi Monitoring", "Pure Sine Wave", "MPPT Technology", "Grid-tie", "Mobile App", "Parallel Operation"],
//       tags: ["featured", "smart-device", "best-seller"],
//       stock: 12,
//       isFeatured: true,
//       specs: { 
//         capacity: "5kW", 
//         type: "Hybrid", 
//         efficiency: "97%", 
//         warranty: "5 years", 
//         connectivity: "WiFi",
//         inputVoltage: "48V",
//         outputVoltage: "230V AC",
//         protection: "IP21"
//       },
//     },
//     {
//       id: 3,
//       name: "Solar Battery 150Ah",
//       description: "Deep cycle solar battery with 10-year warranty",
//       fullDescription: "Maintenance-free deep cycle battery designed specifically for solar applications with excellent cycle life and fast charging capability. Features tubular plate technology for longer life and better performance in high-temperature conditions.",
//       price: 16500,
//       originalPrice: 19000,
//       category: "batteries",
//       rating: 4.6,
//       reviews: 156,
//       image: "/products/battery-1.jpg",
//       images: [
//         "/products/battery-1.jpg",
//         "/products/battery-2.jpg",
//         "/products/battery-3.jpg"
//       ],
//       features: ["150Ah Capacity", "Maintenance Free", "Deep Cycle", "10-year Warranty", "Fast Charge", "Tubular Technology", "High C-rate"],
//       tags: ["value-pack", "long-life", "featured", "best-seller"],
//       stock: 18,
//       isFeatured: true,
//       specs: { 
//         capacity: "150Ah", 
//         voltage: "12V", 
//         warranty: "10 years", 
//         cycles: "2000+", 
//         type: "Deep Cycle",
//         chemistry: "Lead Acid",
//         dimensions: "48×24×24 cm",
//         weight: "45 kg"
//       },
//     },
//     {
//       id: 4,
//       name: "Solar Charge Controller 60A",
//       description: "MPPT charge controller with LCD display",
//       fullDescription: "Advanced MPPT charge controller with temperature compensation and multiple charging modes for optimal battery health. Features LCD display for real-time monitoring and programmable settings for different battery types.",
//       price: 8500,
//       originalPrice: 10500,
//       category: "controllers",
//       rating: 4.5,
//       reviews: 67,
//       image: "/products/controller-1.jpg",
//       images: [
//         "/products/controller-1.jpg",
//         "/products/controller-2.jpg"
//       ],
//       features: ["60A Capacity", "MPPT Technology", "LCD Display", "Temperature Compensation", "USB Port", "Multiple Modes", "Battery Type Selection"],
//       tags: ["energy-efficient"],
//       stock: 30,
//       isFeatured: false,
//       specs: { 
//         capacity: "60A", 
//         type: "MPPT", 
//         efficiency: "98%", 
//         warranty: "3 years", 
//         display: "LCD",
//         inputVoltage: "12/24V",
//         outputVoltage: "12/24V",
//         protection: "IP32"
//       },
//     },
//     {
//       id: 5,
//       name: "Solar Mounting Structure Kit",
//       description: "Complete roof mounting kit for solar panels",
//       fullDescription: "Galvanized steel mounting structure with all necessary hardware for easy installation on various roof types. Includes rails, clamps, end caps, and mounting brackets. Designed for wind resistance and corrosion protection.",
//       price: 12000,
//       originalPrice: 14500,
//       category: "accessories",
//       rating: 4.4,
//       reviews: 42,
//       image: "/products/mounting-1.jpg",
//       images: [
//         "/products/mounting-1.jpg",
//         "/products/mounting-2.jpg"
//       ],
//       features: ["Galvanized Steel", "All Hardware Included", "Adjustable Angle", "Wind Resistant", "Corrosion Proof", "Easy Installation", "Universal Fit"],
//       tags: ["installation", "hardware"],
//       stock: 22,
//       isFeatured: false,
//       specs: { 
//         material: "Galvanized Steel", 
//         capacity: "20 panels", 
//         warranty: "10 years", 
//         adjustment: "0-45 degrees", 
//         corrosion: "Rust Proof",
//         windLoad: "150 km/h",
//         snowLoad: "100 kg/m²"
//       },
//     },
//     {
//       id: 6,
//       name: "Solar Home Kit 3kW",
//       description: "Complete solar solution for homes",
//       fullDescription: "Complete package including 6 solar panels, inverter, batteries, and all accessories for 3kW system with professional installation. Includes monitoring system, wiring, MC4 connectors, and AC/DC breakers. Turnkey solution for residential solar power.",
//       price: 185000,
//       originalPrice: 225000,
//       category: "kits",
//       rating: 4.9,
//       reviews: 203,
//       image: "/products/kit-1.jpg",
//       images: [
//         "/products/kit-1.jpg",
//         "/products/kit-2.jpg",
//         "/products/kit-3.jpg"
//       ],
//       features: ["Complete System", "Professional Installation", "5-year Warranty", "24/7 Support", "WiFi Monitoring", "Grid-tie Ready", "Battery Backup"],
//       tags: ["complete-solution", "best-seller", "installation-included", "featured"],
//       stock: 8,
//       isFeatured: true,
//       specs: { 
//         capacity: "3kW", 
//         components: "Full System", 
//         warranty: "5 years", 
//         installation: "Included", 
//         monitoring: "WiFi",
//         panels: "6 x 500W",
//         inverter: "3kW Hybrid",
//         batteries: "2 x 150Ah"
//       },
//     },
//     {
//       id: 7,
//       name: "Solar Water Heater 100L",
//       description: "Solar thermal water heating system",
//       fullDescription: "Efficient solar water heating system with heat retention technology and backup heating for uninterrupted hot water supply. Features evacuated tube collectors for maximum heat absorption and minimal heat loss.",
//       price: 35000,
//       originalPrice: 42000,
//       category: "heaters",
//       rating: 4.3,
//       reviews: 58,
//       image: "/products/heater-1.jpg",
//       images: [
//         "/products/heater-1.jpg",
//         "/products/heater-2.jpg"
//       ],
//       features: ["100L Capacity", "Heat Retention", "Backup Heating", "Energy Saving", "Auto Temperature Control", "Evacuated Tubes", "Insulated Tank"],
//       tags: ["eco-friendly", "energy-saving"],
//       stock: 15,
//       isFeatured: false,
//       specs: { 
//         capacity: "100L", 
//         type: "Thermal", 
//         warranty: "7 years", 
//         backup: "Electric", 
//         efficiency: "85%",
//         tubes: "20",
//         material: "Stainless Steel",
//         pressure: "Low Pressure"
//       },
//     },
//     {
//       id: 8,
//       name: "Solar Street Light 30W",
//       description: "Automatic solar-powered street light",
//       fullDescription: "Smart street light with motion sensor, automatic dusk-to-dawn operation, and long battery life for energy-efficient outdoor lighting. Features Li-ion battery, high-brightness LED, and intelligent controller for optimal performance.",
//       price: 5500,
//       originalPrice: 7500,
//       category: "lighting",
//       rating: 4.2,
//       reviews: 91,
//       image: "/products/light-1.jpg",
//       images: [
//         "/products/light-1.jpg",
//         "/products/light-2.jpg"
//       ],
//       features: ["30W LED", "Motion Sensor", "Auto On/Off", "2-day Backup", "Weatherproof", "Li-ion Battery", "PIR Sensor"],
//       tags: ["outdoor", "smart-lighting"],
//       stock: 45,
//       isFeatured: false,
//       specs: { 
//         power: "30W", 
//         battery: "Li-ion", 
//         warranty: "3 years", 
//         sensor: "Motion", 
//         autonomy: "2 days",
//         lumen: "3000 lm",
//         height: "6-8 m",
//         material: "Aluminum"
//       },
//     },
//   ];

//   useEffect(() => {
//     fetchProductDetails();
//   }, [id]);

//   const fetchProductDetails = async () => {
//     try {
//       setLoading(true);
//       // Try to fetch from API first
//       const response = await axios.get(`${API_BASE_URL}/products/${id}`);
//       if (response.data.success) {
//         const product = response.data.data;
//         setProduct({
//           id: product._id,
//           name: product.name,
//           description: product.description,
//           fullDescription: product.fullDescription || product.description,
//           price: product.price,
//           originalPrice: product.originalPrice || product.price,
//           category: product.category,
//           rating: product.rating || 4.5,
//           reviews: product.reviews || 0,
//           image: product.imageUrl || getDefaultImage(product.category),
//           images: product.images || [product.imageUrl],
//           features: product.features || [],
//           tags: product.tags || [],
//           stock: product.stock || 0,
//           isFeatured: product.isFeatured || false,
//           specs: product.specifications || {},
//         });
//       } else {
//         // Fallback to static data
//         const staticProduct = productData.find(p => p.id === parseInt(id)) || productData[0];
//         setProduct(staticProduct);
//       }
//     } catch (error) {
//       console.error('Error fetching product:', error);
//       // Fallback to static data
//       const staticProduct = productData.find(p => p.id === parseInt(id)) || productData[0];
//       setProduct(staticProduct);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getDefaultImage = (category) => {
//     const categoryMap = {
//       'Solar Panels': '/products/solar-panel-1.jpg',
//       'Inverters': '/products/inverter-1.jpg',
//       'Batteries': '/products/battery-1.jpg',
//       'Controllers': '/products/controller-1.jpg',
//       'Accessories': '/products/mounting-1.jpg',
//       'Complete Kits': '/products/kit-1.jpg',
//       'Water Heaters': '/products/heater-1.jpg',
//       'Solar Lighting': '/products/light-1.jpg'
//     };
//     return categoryMap[category] || '/images/default-product.jpg';
//   };

//   const handleAddToCart = () => {
//     // Get existing cart from localStorage
//     const existingCart = JSON.parse(localStorage.getItem('cart') || '[]');
    
//     // Check if product already exists in cart
//     const existingItem = existingCart.find(item => item.id === product.id);
    
//     if (existingItem) {
//       existingItem.quantity += quantity;
//     } else {
//       existingCart.push({
//         ...product,
//         quantity: quantity
//       });
//     }
    
//     // Save to localStorage
//     localStorage.setItem('cart', JSON.stringify(existingCart));
    
//     alert(`✅ ${product.name} added to cart!`);
//   };

//   const handleBuyNow = () => {
//     setShowOptions(true);
//   };

//   const handleWhatsAppOrder = () => {
//     const productDetails = `
// *Order Details*
// -------------------
// *Product:* ${product.name}
// *Price:* ₹${product.price.toLocaleString()}
// *Quantity:* ${quantity}
// *Total:* ₹${(product.price * quantity).toLocaleString()}
// -------------------

// Hi, I'm interested in ordering:
// ${product.name}
// Quantity: ${quantity}
// Total Amount: ₹${(product.price * quantity).toLocaleString()}

// Please provide me with more details about:
// • Delivery timeline
// • Payment options
// • Installation process
// • Warranty information

// Thank you!
//     `.trim();

//     const encodedMessage = encodeURIComponent(productDetails);
//     const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
//     window.open(whatsappUrl, '_blank');
//     setShowOptions(false);
//   };

//   const handleCallOrder = () => {
//     window.location.href = `tel:${WHATSAPP_NUMBER}`;
//     setShowOptions(false);
//   };

//   if (loading) {
//     return (
//       <div style={styles.loadingContainer}>
//         <div style={styles.loader}></div>
//         <p>Loading product details...</p>
//       </div>
//     );
//   }

//   if (!product) {
//     return (
//       <div style={styles.errorContainer}>
//         <h2>Product not found</h2>
//         <button 
//           style={styles.backButton}
//           onClick={() => navigate('/products')}
//         >
//           Back to Products
//         </button>
//       </div>
//     );
//   }

//   const discountPercentage = product.originalPrice > product.price 
//     ? Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)
//     : 0;

//   return (
//     <div style={styles.container}>
//       {/* Options Modal */}
//       {showOptions && (
//         <div style={styles.modalOverlay} onClick={() => setShowOptions(false)}>
//           <div style={styles.modal} onClick={e => e.stopPropagation()}>
//             <h3 style={styles.modalTitle}>Contact Options</h3>
//             <p style={styles.modalProduct}>{product.name}</p>
//             <p style={styles.modalPrice}>Total: ₹{(product.price * quantity).toLocaleString()}</p>
            
//             <button 
//               style={styles.whatsappOption}
//               onClick={handleWhatsAppOrder}
//               onMouseEnter={(e) => e.target.style.background = '#128C7E'}
//               onMouseLeave={(e) => e.target.style.background = '#25D366'}
//             >
//               <span style={{fontSize: '24px', marginRight: '10px'}}>📱</span>
//               Order via WhatsApp
//             </button>
            
//             <button 
//               style={styles.callOption}
//               onClick={handleCallOrder}
//               onMouseEnter={(e) => e.target.style.background = '#0D47A1'}
//               onMouseLeave={(e) => e.target.style.background = '#1976D2'}
//             >
//               <span style={{fontSize: '24px', marginRight: '10px'}}>📞</span>
//               Call to Order
//             </button>
            
//             <button 
//               style={styles.closeOption}
//               onClick={() => setShowOptions(false)}
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Back Button */}
//       <button 
//         style={styles.backButton}
//         onClick={() => navigate('/products')}
//       >
//         ← Back to Products
//       </button>

//       {/* Main Product Detail */}
//       <div style={styles.productContainer}>
//         {/* Left Side - Images */}
//         <div style={styles.imageSection}>
//           <div style={styles.mainImage}>
//             {product.image ? (
//               <img 
//                 src={product.image} 
//                 alt={product.name}
//                 style={styles.mainImageTag}
//                 onError={(e) => {
//                   e.target.onerror = null;
//                   e.target.style.display = 'none';
//                   e.target.parentNode.innerHTML = getCategoryIcon(product.category);
//                 }}
//               />
//             ) : (
//               <div style={styles.imagePlaceholder}>
//                 {getCategoryIcon(product.category)}
//               </div>
//             )}
//           </div>
          
//           <div style={styles.thumbnailContainer}>
//             {(product.images || [product.image]).map((img, index) => (
//               <div 
//                 key={index}
//                 style={{
//                   ...styles.thumbnail,
//                   border: selectedImage === index ? '2px solid #447793' : '1px solid #DDE8ED'
//                 }}
//                 onClick={() => setSelectedImage(index)}
//               >
//                 {img ? (
//                   <img 
//                     src={img} 
//                     alt={`${product.name} - ${index + 1}`}
//                     style={styles.thumbnailImage}
//                   />
//                 ) : (
//                   <div style={styles.thumbnailPlaceholder}>
//                     {getCategoryIcon(product.category)}
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Right Side - Details */}
//         <div style={styles.detailsSection}>
//           {/* Title and Rating */}
//           <h1 style={styles.productName}>{product.name}</h1>
          
//           <div style={styles.ratingContainer}>
//             <div style={styles.stars}>
//               {"★".repeat(Math.floor(product.rating))}
//               {"☆".repeat(5 - Math.floor(product.rating))}
//             </div>
//             <span style={styles.reviewCount}>({product.reviews} reviews)</span>
//           </div>

//           {/* Price Section */}
//           <div style={styles.priceSection}>
//             <span style={styles.currentPrice}>₹{product.price.toLocaleString()}</span>
//             {product.originalPrice > product.price && (
//               <>
//                 <span style={styles.originalPrice}>₹{product.originalPrice.toLocaleString()}</span>
//                 <span style={styles.discountBadge}>{discountPercentage}% OFF</span>
//               </>
//             )}
//           </div>

//           {/* Savings */}
//           {product.originalPrice > product.price && (
//             <div style={styles.savings}>
//               You Save: ₹{(product.originalPrice - product.price).toLocaleString()}
//             </div>
//           )}

//           {/* Availability */}
//           <div style={styles.availability}>
//             <span style={product.stock > 0 ? styles.inStock : styles.outOfStock}>
//               {product.stock > 0 ? `✅ In Stock (${product.stock} available)` : '❌ Out of Stock'}
//             </span>
//           </div>

//           {/* Short Description */}
//           <p style={styles.description}>{product.description}</p>

//           {/* Key Features */}
//           <div style={styles.featuresSection}>
//             <h3 style={styles.sectionTitle}>Key Features</h3>
//             <ul style={styles.featuresList}>
//               {product.features.map((feature, index) => (
//                 <li key={index} style={styles.featureItem}>✓ {feature}</li>
//               ))}
//             </ul>
//           </div>

//           {/* Quantity Selector */}
//           <div style={styles.quantitySection}>
//             <label style={styles.quantityLabel}>Quantity:</label>
//             <div style={styles.quantityControl}>
//               <button 
//                 style={styles.quantityBtn}
//                 onClick={() => setQuantity(Math.max(1, quantity - 1))}
//               >
//                 -
//               </button>
//               <input 
//                 type="number" 
//                 value={quantity}
//                 onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))}
//                 style={styles.quantityInput}
//                 min="1"
//                 max={product.stock}
//               />
//               <button 
//                 style={styles.quantityBtn}
//                 onClick={() => setQuantity(Math.min(product.stock, quantity + 1))}
//               >
//                 +
//               </button>
//             </div>
//           </div>

//           {/* Action Buttons */}
//           <div style={styles.actionButtons}>
//             <button 
//               style={styles.addToCartBtn}
//               onClick={handleAddToCart}
//               onMouseEnter={(e) => e.target.style.background = '#2D5A74'}
//               onMouseLeave={(e) => e.target.style.background = '#447793'}
//             >
//               🛒 Add to Cart
//             </button>
//             <button 
//               style={styles.buyNowBtn}
//               onClick={handleBuyNow}
//               onMouseEnter={(e) => e.target.style.background = '#123249'}
//               onMouseLeave={(e) => e.target.style.background = '#2D5A74'}
//             >
//               ⚡ Buy Now
//             </button>
//           </div>

//           {/* Delivery Info */}
//           <div style={styles.deliveryInfo}>
//             <div style={styles.deliveryItem}>
//               <span style={styles.deliveryIcon}>🚚</span>
//               <span>Free Delivery</span>
//             </div>
//             <div style={styles.deliveryItem}>
//               <span style={styles.deliveryIcon}>⚡</span>
//               <span>Easy Returns</span>
//             </div>
//             <div style={styles.deliveryItem}>
//               <span style={styles.deliveryIcon}>🔧</span>
//               <span>Installation Available</span>
//             </div>
//           </div>

//           {/* Full Description */}
//           <div style={styles.fullDescription}>
//             <h3 style={styles.sectionTitle}>Product Description</h3>
//             <p style={styles.fullDescriptionText}>{product.fullDescription}</p>
//           </div>

//           {/* Specifications */}
//           {product.specs && Object.keys(product.specs).length > 0 && (
//             <div style={styles.specsSection}>
//               <h3 style={styles.sectionTitle}>Specifications</h3>
//               <table style={styles.specsTable}>
//                 <tbody>
//                   {Object.entries(product.specs).map(([key, value]) => (
//                     <tr key={key}>
//                       <td style={styles.specKey}>{key.charAt(0).toUpperCase() + key.slice(1)}</td>
//                       <td style={styles.specValue}>{value}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// // Helper function for category icons
// const getCategoryIcon = (category) => {
//   const icons = {
//     'panels': '☀️',
//     'inverters': '⚡',
//     'batteries': '🔋',
//     'controllers': '🎛️',
//     'accessories': '🔧',
//     'kits': '📦',
//     'heaters': '♨️',
//     'lighting': '💡'
//   };
//   return icons[category] || '📦';
// };

// const styles = {
//   container: {
//     maxWidth: '1200px',
//     margin: '0 auto',
//     padding: '20px',
//     fontFamily: 'Cambria, serif',
//     backgroundColor: '#ffffff',
//     minHeight: '100vh',
//   },
//   loadingContainer: {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     justifyContent: 'center',
//     height: '100vh',
//     backgroundColor: '#f5f7fa',
//   },
//   loader: {
//     border: '4px solid #DDE8ED',
//     borderTop: '4px solid #447793',
//     borderRadius: '50%',
//     width: '40px',
//     height: '40px',
//     animation: 'spin 1s linear infinite',
//     marginBottom: '20px',
//   },
//   errorContainer: {
//     textAlign: 'center',
//     padding: '50px',
//     color: '#123249',
//   },
//   backButton: {
//     backgroundColor: '#447793',
//     color: 'white',
//     border: 'none',
//     padding: '10px 20px',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     fontSize: '1rem',
//     marginBottom: '20px',
//     transition: 'background-color 0.3s',
//   },
//   productContainer: {
//     display: 'grid',
//     gridTemplateColumns: '1fr 1fr',
//     gap: '40px',
//     backgroundColor: 'white',
//     borderRadius: '15px',
//     padding: '30px',
//     boxShadow: '0 5px 20px rgba(6, 18, 33, 0.08)',
//   },
//   imageSection: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '20px',
//   },
//   mainImage: {
//     width: '100%',
//     height: '400px',
//     backgroundColor: '#DDE8ED',
//     borderRadius: '15px',
//     overflow: 'hidden',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     border: '1px solid #DDE8ED',
//   },
//   mainImageTag: {
//     width: '100%',
//     height: '100%',
//     objectFit: 'contain',
//   },
//   imagePlaceholder: {
//     fontSize: '5rem',
//     color: '#123249',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     width: '100%',
//     height: '100%',
//   },
//   thumbnailContainer: {
//     display: 'flex',
//     gap: '10px',
//     flexWrap: 'wrap',
//   },
//   thumbnail: {
//     width: '80px',
//     height: '80px',
//     backgroundColor: '#DDE8ED',
//     borderRadius: '8px',
//     overflow: 'hidden',
//     cursor: 'pointer',
//     transition: 'all 0.3s',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//   },
//   thumbnailImage: {
//     width: '100%',
//     height: '100%',
//     objectFit: 'cover',
//   },
//   thumbnailPlaceholder: {
//     fontSize: '1.5rem',
//     color: '#123249',
//   },
//   detailsSection: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '15px',
//   },
//   productName: {
//     fontSize: '2rem',
//     fontWeight: '700',
//     color: '#123249',
//     margin: 0,
//   },
//   ratingContainer: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px',
//   },
//   stars: {
//     color: '#447793',
//     fontSize: '1.2rem',
//     letterSpacing: '2px',
//   },
//   reviewCount: {
//     color: '#2D5A74',
//     fontSize: '0.9rem',
//   },
//   priceSection: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '15px',
//     flexWrap: 'wrap',
//     padding: '15px 0',
//     borderTop: '1px solid #DDE8ED',
//     borderBottom: '1px solid #DDE8ED',
//   },
//   currentPrice: {
//     fontSize: '2.5rem',
//     fontWeight: '800',
//     color: '#123249',
//   },
//   originalPrice: {
//     fontSize: '1.5rem',
//     color: '#2D5A74',
//     textDecoration: 'line-through',
//   },
//   discountBadge: {
//     backgroundColor: '#447793',
//     color: 'white',
//     padding: '5px 12px',
//     borderRadius: '20px',
//     fontSize: '1rem',
//     fontWeight: '600',
//   },
//   savings: {
//     fontSize: '1.1rem',
//     color: '#447793',
//     fontWeight: '600',
//   },
//   availability: {
//     marginBottom: '10px',
//   },
//   inStock: {
//     color: '#447793',
//     fontWeight: '600',
//   },
//   outOfStock: {
//     color: '#2D5A74',
//     fontWeight: '600',
//   },
//   description: {
//     fontSize: '1rem',
//     color: '#2D5A74',
//     lineHeight: '1.6',
//     margin: '10px 0',
//   },
//   featuresSection: {
//     margin: '15px 0',
//   },
//   sectionTitle: {
//     fontSize: '1.2rem',
//     fontWeight: '700',
//     color: '#123249',
//     marginBottom: '10px',
//   },
//   featuresList: {
//     listStyle: 'none',
//     padding: 0,
//     margin: 0,
//     display: 'grid',
//     gridTemplateColumns: 'repeat(2, 1fr)',
//     gap: '10px',
//   },
//   featureItem: {
//     color: '#2D5A74',
//     fontSize: '0.95rem',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '5px',
//   },
//   quantitySection: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '15px',
//     margin: '15px 0',
//   },
//   quantityLabel: {
//     fontSize: '1rem',
//     fontWeight: '600',
//     color: '#123249',
//   },
//   quantityControl: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '5px',
//   },
//   quantityBtn: {
//     width: '35px',
//     height: '35px',
//     backgroundColor: '#DDE8ED',
//     border: 'none',
//     borderRadius: '5px',
//     cursor: 'pointer',
//     fontSize: '1.2rem',
//     color: '#123249',
//     transition: 'all 0.3s',
//   },
//   quantityInput: {
//     width: '60px',
//     height: '35px',
//     textAlign: 'center',
//     border: '1px solid #DDE8ED',
//     borderRadius: '5px',
//     fontSize: '1rem',
//     color: '#123249',
//   },
//   actionButtons: {
//     display: 'grid',
//     gridTemplateColumns: '1fr 1fr',
//     gap: '15px',
//     margin: '20px 0',
//   },
//   addToCartBtn: {
//     padding: '15px',
//     backgroundColor: '#447793',
//     color: 'white',
//     border: 'none',
//     borderRadius: '10px',
//     fontSize: '1.1rem',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.3s',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     gap: '10px',
//   },
//   buyNowBtn: {
//     padding: '15px',
//     backgroundColor: '#2D5A74',
//     color: 'white',
//     border: 'none',
//     borderRadius: '10px',
//     fontSize: '1.1rem',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.3s',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     gap: '10px',
//   },
//   deliveryInfo: {
//     display: 'flex',
//     gap: '20px',
//     padding: '15px 0',
//     borderTop: '1px solid #DDE8ED',
//     borderBottom: '1px solid #DDE8ED',
//   },
//   deliveryItem: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     color: '#123249',
//     fontSize: '0.9rem',
//   },
//   deliveryIcon: {
//     fontSize: '1.2rem',
//   },
//   fullDescription: {
//     margin: '15px 0',
//   },
//   fullDescriptionText: {
//     color: '#2D5A74',
//     lineHeight: '1.8',
//     fontSize: '0.95rem',
//   },
//   specsSection: {
//     margin: '15px 0',
//   },
//   specsTable: {
//     width: '100%',
//     borderCollapse: 'collapse',
//     backgroundColor: '#f8fafc',
//     borderRadius: '10px',
//     overflow: 'hidden',
//   },
//   specKey: {
//     padding: '12px 15px',
//     borderBottom: '1px solid #DDE8ED',
//     fontWeight: '600',
//     color: '#123249',
//     width: '40%',
//   },
//   specValue: {
//     padding: '12px 15px',
//     borderBottom: '1px solid #DDE8ED',
//     color: '#2D5A74',
//   },
//   modalOverlay: {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: 'rgba(6, 18, 33, 0.5)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 1000,
//   },
//   modal: {
//     backgroundColor: 'white',
//     padding: '30px',
//     borderRadius: '15px',
//     maxWidth: '400px',
//     width: '90%',
//     textAlign: 'center',
//   },
//   modalTitle: {
//     fontSize: '1.5rem',
//     fontWeight: '700',
//     color: '#123249',
//     marginBottom: '10px',
//   },
//   modalProduct: {
//     fontSize: '1rem',
//     color: '#2D5A74',
//     marginBottom: '10px',
//   },
//   modalPrice: {
//     fontSize: '1.2rem',
//     fontWeight: '600',
//     color: '#447793',
//     marginBottom: '20px',
//   },
//   whatsappOption: {
//     width: '100%',
//     padding: '15px',
//     backgroundColor: '#25D366',
//     color: 'white',
//     border: 'none',
//     borderRadius: '10px',
//     fontSize: '1rem',
//     fontWeight: '600',
//     cursor: 'pointer',
//     marginBottom: '10px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     transition: 'all 0.3s',
//   },
//   callOption: {
//     width: '100%',
//     padding: '15px',
//     backgroundColor: '#1976D2',
//     color: 'white',
//     border: 'none',
//     borderRadius: '10px',
//     fontSize: '1rem',
//     fontWeight: '600',
//     cursor: 'pointer',
//     marginBottom: '10px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     transition: 'all 0.3s',
//   },
//   closeOption: {
//     width: '100%',
//     padding: '10px',
//     backgroundColor: 'transparent',
//     color: '#123249',
//     border: '1px solid #DDE8ED',
//     borderRadius: '10px',
//     fontSize: '0.95rem',
//     cursor: 'pointer',
//     transition: 'all 0.3s',
//   },
// };

// // Add animation keyframes
// const styleSheet = document.createElement("style");
// styleSheet.textContent = `
//   @keyframes spin {
//     0% { transform: rotate(0deg); }
//     100% { transform: rotate(360deg); }
//   }
// `;
// document.head.appendChild(styleSheet);

// export default ProductDetail;


















// components/ProductDetail.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [showOptions, setShowOptions] = useState(false);

  const API_BASE_URL = 'http://localhost:5000/api';
  const WHATSAPP_NUMBER = '8421377814';

  // Static fallback data
  const productData = [
    {
      id: 1,
      name: "SolarSquare Flexi 300W Panel",
      description: "High-efficiency monocrystalline solar panel with 21.5% efficiency",
      fullDescription: "Premium monocrystalline solar panel with anti-reflective coating, superior low-light performance, and 25-year linear power output warranty. Perfect for residential rooftops. Features advanced PERC technology for higher efficiency and better performance in low-light conditions.",
      price: 18500,
      originalPrice: 21500,
      category: "panels",
      rating: 4.8,
      reviews: 124,
      image: "/products/solar-panel-1.jpg",
      images: [
        "/products/solar-panel-1.jpg",
        "/products/solar-panel-2.jpg",
        "/products/solar-panel-3.jpg"
      ],
      features: ["300W Output", "25-year Warranty", "Weather Resistant", "Easy Installation", "High Efficiency", "PERC Technology", "Anti-reflective Coating"],
      tags: ["best-seller", "new-arrival", "featured"],
      stock: 25,
      isFeatured: true,
      specs: { 
        power: "300W", 
        efficiency: "21.5%", 
        warranty: "25 years", 
        dimensions: "175×100 cm", 
        weight: "18 kg",
        cellType: "Monocrystalline",
        operatingTemp: "-40°C to +85°C",
        maxVoltage: "1000V"
      },
    },
    {
      id: 2,
      name: "SmartSolar Inverter 5kW",
      description: "Hybrid solar inverter with battery backup",
      fullDescription: "Smart hybrid inverter with WiFi monitoring, pure sine wave output, and seamless grid-tie functionality. Includes mobile app for real-time monitoring.",
      price: 45000,
      originalPrice: 52000,
      category: "inverters",
      rating: 4.7,
      reviews: 89,
      image: "/products/inverter-1.jpg",
      images: [
        "/products/inverter-1.jpg",
        "/products/inverter-2.jpg",
        "/products/inverter-3.jpg"
      ],
      features: ["5kW Capacity", "WiFi Monitoring", "Pure Sine Wave", "MPPT Technology", "Grid-tie"],
      tags: ["featured", "smart-device", "best-seller"],
      stock: 12,
      isFeatured: true,
      specs: { 
        capacity: "5kW", 
        type: "Hybrid", 
        efficiency: "97%", 
        warranty: "5 years", 
        connectivity: "WiFi",
        inputVoltage: "48V",
        outputVoltage: "230V AC",
        protection: "IP21"
      },
    },
    {
      id: 3,
      name: "Solar Battery 150Ah",
      description: "Deep cycle solar battery with 10-year warranty",
      fullDescription: "Maintenance-free deep cycle battery designed specifically for solar applications with excellent cycle life and fast charging capability.",
      price: 16500,
      originalPrice: 19000,
      category: "batteries",
      rating: 4.6,
      reviews: 156,
      image: "/products/battery-1.jpg",
      images: [
        "/products/battery-1.jpg",
        "/products/battery-2.jpg",
        "/products/battery-3.jpg"
      ],
      features: ["150Ah Capacity", "Maintenance Free", "Deep Cycle", "10-year Warranty", "Fast Charge"],
      tags: ["value-pack", "long-life", "featured", "best-seller"],
      stock: 18,
      isFeatured: true,
      specs: { 
        capacity: "150Ah", 
        voltage: "12V", 
        warranty: "10 years", 
        cycles: "2000+", 
        type: "Deep Cycle",
        chemistry: "Lead Acid",
        dimensions: "48×24×24 cm",
        weight: "45 kg"
      },
    },
    {
      id: 4,
      name: "Solar Charge Controller 60A",
      description: "MPPT charge controller with LCD display",
      fullDescription: "Advanced MPPT charge controller with temperature compensation and multiple charging modes for optimal battery health.",
      price: 8500,
      originalPrice: 10500,
      category: "controllers",
      rating: 4.5,
      reviews: 67,
      image: "/products/controller-1.jpg",
      images: [
        "/products/controller-1.jpg",
        "/products/controller-2.jpg"
      ],
      features: ["60A Capacity", "MPPT Technology", "LCD Display", "Temperature Compensation", "USB Port"],
      tags: ["energy-efficient"],
      stock: 30,
      isFeatured: false,
      specs: { 
        capacity: "60A", 
        type: "MPPT", 
        efficiency: "98%", 
        warranty: "3 years", 
        display: "LCD",
        inputVoltage: "12/24V",
        outputVoltage: "12/24V",
        protection: "IP32"
      },
    },
    {
      id: 5,
      name: "Solar Mounting Structure Kit",
      description: "Complete roof mounting kit for solar panels",
      fullDescription: "Galvanized steel mounting structure with all necessary hardware for easy installation on various roof types.",
      price: 12000,
      originalPrice: 14500,
      category: "accessories",
      rating: 4.4,
      reviews: 42,
      image: "/products/mounting-1.jpg",
      images: [
        "/products/mounting-1.jpg",
        "/products/mounting-2.jpg"
      ],
      features: ["Galvanized Steel", "All Hardware Included", "Adjustable Angle", "Wind Resistant", "Corrosion Proof"],
      tags: ["installation", "hardware"],
      stock: 22,
      isFeatured: false,
      specs: { 
        material: "Galvanized Steel", 
        capacity: "20 panels", 
        warranty: "10 years", 
        adjustment: "0-45 degrees", 
        corrosion: "Rust Proof",
        windLoad: "150 km/h",
        snowLoad: "100 kg/m²"
      },
    },
    {
      id: 6,
      name: "Solar Home Kit 3kW",
      description: "Complete solar solution for homes",
      fullDescription: "Complete package including 6 solar panels, inverter, batteries, and all accessories for 3kW system with professional installation.",
      price: 185000,
      originalPrice: 225000,
      category: "kits",
      rating: 4.9,
      reviews: 203,
      image: "/products/kit-1.jpg",
      images: [
        "/products/kit-1.jpg",
        "/products/kit-2.jpg",
        "/products/kit-3.jpg"
      ],
      features: ["Complete System", "Professional Installation", "5-year Warranty", "24/7 Support", "WiFi Monitoring"],
      tags: ["complete-solution", "best-seller", "installation-included", "featured"],
      stock: 8,
      isFeatured: true,
      specs: { 
        capacity: "3kW", 
        components: "Full System", 
        warranty: "5 years", 
        installation: "Included", 
        monitoring: "WiFi",
        panels: "6 x 500W",
        inverter: "3kW Hybrid",
        batteries: "2 x 150Ah"
      },
    },
    {
      id: 7,
      name: "Solar Water Heater 100L",
      description: "Solar thermal water heating system",
      fullDescription: "Efficient solar water heating system with heat retention technology and backup heating for uninterrupted hot water supply.",
      price: 35000,
      originalPrice: 42000,
      category: "heaters",
      rating: 4.3,
      reviews: 58,
      image: "/products/heater-1.jpg",
      images: [
        "/products/heater-1.jpg",
        "/products/heater-2.jpg"
      ],
      features: ["100L Capacity", "Heat Retention", "Backup Heating", "Energy Saving", "Auto Temperature Control"],
      tags: ["eco-friendly", "energy-saving"],
      stock: 15,
      isFeatured: false,
      specs: { 
        capacity: "100L", 
        type: "Thermal", 
        warranty: "7 years", 
        backup: "Electric", 
        efficiency: "85%",
        tubes: "20",
        material: "Stainless Steel",
        pressure: "Low Pressure"
      },
    },
    {
      id: 8,
      name: "Solar Street Light 30W",
      description: "Automatic solar-powered street light",
      fullDescription: "Smart street light with motion sensor, automatic dusk-to-dawn operation, and long battery life for energy-efficient outdoor lighting.",
      price: 5500,
      originalPrice: 7500,
      category: "lighting",
      rating: 4.2,
      reviews: 91,
      image: "/products/light-1.jpg",
      images: [
        "/products/light-1.jpg",
        "/products/light-2.jpg"
      ],
      features: ["30W LED", "Motion Sensor", "Auto On/Off", "2-day Backup", "Weatherproof"],
      tags: ["outdoor", "smart-lighting"],
      stock: 45,
      isFeatured: false,
      specs: { 
        power: "30W", 
        battery: "Li-ion", 
        warranty: "3 years", 
        sensor: "Motion", 
        autonomy: "2 days",
        lumen: "3000 lm",
        height: "6-8 m",
        material: "Aluminum"
      },
    },
  ];

  useEffect(() => {
    fetchProductDetails();
  }, [id]);

  const fetchProductDetails = async () => {
    try {
      setLoading(true);
      // Try to fetch from API first
      try {
        const response = await axios.get(`${API_BASE_URL}/products/${id}`);
        if (response.data.success) {
          const product = response.data.data;
          setProduct({
            id: product._id,
            name: product.name,
            description: product.description,
            fullDescription: product.fullDescription || product.description,
            price: product.price,
            originalPrice: product.originalPrice || product.price,
            category: product.category,
            rating: product.rating || 4.5,
            reviews: product.reviews || 0,
            image: product.imageUrl || getDefaultImage(product.category),
            images: product.images || [product.imageUrl],
            features: product.features || [],
            tags: product.tags || [],
            stock: product.stock || 0,
            isFeatured: product.isFeatured || false,
            specs: product.specifications || {},
          });
        } else {
          // Fallback to static data
          const staticProduct = productData.find(p => p.id === parseInt(id)) || productData[0];
          setProduct(staticProduct);
        }
      } catch (error) {
        console.error('Error fetching from API:', error);
        // Fallback to static data
        const staticProduct = productData.find(p => p.id === parseInt(id)) || productData[0];
        setProduct(staticProduct);
      }
    } catch (err) {
      console.error('Error:', err);
      setError('Failed to load product details');
    } finally {
      setLoading(false);
    }
  };

  const getDefaultImage = (category) => {
    const categoryMap = {
      'Solar Panels': '/products/solar-panel-1.jpg',
      'Inverters': '/products/inverter-1.jpg',
      'Batteries': '/products/battery-1.jpg',
      'Controllers': '/products/controller-1.jpg',
      'Accessories': '/products/mounting-1.jpg',
      'Complete Kits': '/products/kit-1.jpg',
      'Water Heaters': '/products/heater-1.jpg',
      'Solar Lighting': '/products/light-1.jpg'
    };
    return categoryMap[category] || '/images/default-product.jpg';
  };

  const handleAddToCart = () => {
    // Get existing cart from localStorage
    const existingCart = JSON.parse(localStorage.getItem('cart') || '[]');
    
    // Check if product already exists in cart
    const existingItem = existingCart.find(item => item.id === product.id);
    
    if (existingItem) {
      existingItem.quantity += quantity;
    } else {
      existingCart.push({
        ...product,
        quantity: quantity
      });
    }
    
    // Save to localStorage
    localStorage.setItem('cart', JSON.stringify(existingCart));
    
    alert(`✅ ${product.name} added to cart!`);
  };

  const handleBuyNow = () => {
    setShowOptions(true);
  };

  const handleWhatsAppOrder = () => {
    const productDetails = `
*Order Details*
-------------------
*Product:* ${product.name}
*Price:* ₹${product.price.toLocaleString()}
*Quantity:* ${quantity}
*Total:* ₹${(product.price * quantity).toLocaleString()}
-------------------

Hi, I'm interested in ordering:
${product.name}
Quantity: ${quantity}
Total Amount: ₹${(product.price * quantity).toLocaleString()}

Please provide me with more details about:
• Delivery timeline
• Payment options
• Installation process
• Warranty information

Thank you!
    `.trim();

    const encodedMessage = encodeURIComponent(productDetails);
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
    setShowOptions(false);
  };

  const handleCallOrder = () => {
    window.location.href = `tel:${WHATSAPP_NUMBER}`;
    setShowOptions(false);
  };

  const getCategoryIcon = (category) => {
    const icons = {
      'panels': '☀️',
      'inverters': '⚡',
      'batteries': '🔋',
      'controllers': '🎛️',
      'accessories': '🔧',
      'kits': '📦',
      'heaters': '♨️',
      'lighting': '💡'
    };
    return icons[category] || '📦';
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f5f7fa',
        fontFamily: 'Cambria, serif',
      }}>
        <div style={{
          border: '4px solid #DDE8ED',
          borderTop: '4px solid #447793',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          animation: 'spin 1s linear infinite',
          marginBottom: '20px',
        }}></div>
        <p style={{ color: '#123249' }}>Loading product details...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (error || !product) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '50px',
        color: '#123249',
        fontFamily: 'Cambria, serif',
      }}>
        <h2>Product not found</h2>
        <button 
          style={{
            backgroundColor: '#447793',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '1rem',
            marginTop: '20px',
            transition: 'background-color 0.3s',
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#2D5A74'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#447793'}
          onClick={() => navigate('/products')}
        >
          Back to Products
        </button>
      </div>
    );
  }

  const discountPercentage = product.originalPrice > product.price 
    ? Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)
    : 0;

  const styles = {
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
      fontFamily: 'Cambria, serif',
      backgroundColor: '#ffffff',
      minHeight: '100vh',
    },
    backButton: {
      backgroundColor: '#447793',
      color: 'white',
      border: 'none',
      padding: '10px 20px',
      borderRadius: '8px',
      cursor: 'pointer',
      fontSize: '1rem',
      marginBottom: '20px',
      transition: 'background-color 0.3s',
    },
    productContainer: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '40px',
      backgroundColor: 'white',
      borderRadius: '15px',
      padding: '30px',
      boxShadow: '0 5px 20px rgba(6, 18, 33, 0.08)',
    },
    imageSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
    },
    mainImage: {
      width: '100%',
      height: '400px',
      backgroundColor: '#DDE8ED',
      borderRadius: '15px',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid #DDE8ED',
    },
    mainImageTag: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
    imagePlaceholder: {
      fontSize: '5rem',
      color: '#123249',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
    },
    thumbnailContainer: {
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap',
    },
    thumbnail: {
      width: '80px',
      height: '80px',
      backgroundColor: '#DDE8ED',
      borderRadius: '8px',
      overflow: 'hidden',
      cursor: 'pointer',
      transition: 'all 0.3s',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    thumbnailImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    thumbnailPlaceholder: {
      fontSize: '1.5rem',
      color: '#123249',
    },
    detailsSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px',
    },
    productName: {
      fontSize: '2rem',
      fontWeight: '700',
      color: '#123249',
      margin: 0,
    },
    ratingContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    stars: {
      color: '#447793',
      fontSize: '1.2rem',
      letterSpacing: '2px',
    },
    reviewCount: {
      color: '#2D5A74',
      fontSize: '0.9rem',
    },
    priceSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      flexWrap: 'wrap',
      padding: '15px 0',
      borderTop: '1px solid #DDE8ED',
      borderBottom: '1px solid #DDE8ED',
    },
    currentPrice: {
      fontSize: '2.5rem',
      fontWeight: '800',
      color: '#123249',
    },
    originalPrice: {
      fontSize: '1.5rem',
      color: '#2D5A74',
      textDecoration: 'line-through',
    },
    discountBadge: {
      backgroundColor: '#447793',
      color: 'white',
      padding: '5px 12px',
      borderRadius: '20px',
      fontSize: '1rem',
      fontWeight: '600',
    },
    savings: {
      fontSize: '1.1rem',
      color: '#447793',
      fontWeight: '600',
    },
    availability: {
      marginBottom: '10px',
    },
    inStock: {
      color: '#447793',
      fontWeight: '600',
    },
    outOfStock: {
      color: '#2D5A74',
      fontWeight: '600',
    },
    description: {
      fontSize: '1rem',
      color: '#2D5A74',
      lineHeight: '1.6',
      margin: '10px 0',
    },
    featuresSection: {
      margin: '15px 0',
    },
    sectionTitle: {
      fontSize: '1.2rem',
      fontWeight: '700',
      color: '#123249',
      marginBottom: '10px',
    },
    featuresList: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '10px',
    },
    featureItem: {
      color: '#2D5A74',
      fontSize: '0.95rem',
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
    },
    quantitySection: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      margin: '15px 0',
    },
    quantityLabel: {
      fontSize: '1rem',
      fontWeight: '600',
      color: '#123249',
    },
    quantityControl: {
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
    },
    quantityBtn: {
      width: '35px',
      height: '35px',
      backgroundColor: '#DDE8ED',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      fontSize: '1.2rem',
      color: '#123249',
      transition: 'all 0.3s',
    },
    quantityInput: {
      width: '60px',
      height: '35px',
      textAlign: 'center',
      border: '1px solid #DDE8ED',
      borderRadius: '5px',
      fontSize: '1rem',
      color: '#123249',
    },
    actionButtons: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '15px',
      margin: '20px 0',
    },
    addToCartBtn: {
      padding: '15px',
      backgroundColor: '#447793',
      color: 'white',
      border: 'none',
      borderRadius: '10px',
      fontSize: '1.1rem',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
    },
    buyNowBtn: {
      padding: '15px',
      backgroundColor: '#2D5A74',
      color: 'white',
      border: 'none',
      borderRadius: '10px',
      fontSize: '1.1rem',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
    },
    deliveryInfo: {
      display: 'flex',
      gap: '20px',
      padding: '15px 0',
      borderTop: '1px solid #DDE8ED',
      borderBottom: '1px solid #DDE8ED',
    },
    deliveryItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      color: '#123249',
      fontSize: '0.9rem',
    },
    deliveryIcon: {
      fontSize: '1.2rem',
    },
    fullDescription: {
      margin: '15px 0',
    },
    fullDescriptionText: {
      color: '#2D5A74',
      lineHeight: '1.8',
      fontSize: '0.95rem',
    },
    specsSection: {
      margin: '15px 0',
    },
    specsTable: {
      width: '100%',
      borderCollapse: 'collapse',
      backgroundColor: '#f8fafc',
      borderRadius: '10px',
      overflow: 'hidden',
    },
    specKey: {
      padding: '12px 15px',
      borderBottom: '1px solid #DDE8ED',
      fontWeight: '600',
      color: '#123249',
      width: '40%',
    },
    specValue: {
      padding: '12px 15px',
      borderBottom: '1px solid #DDE8ED',
      color: '#2D5A74',
    },
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(6, 18, 33, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    },
    modal: {
      backgroundColor: 'white',
      padding: '30px',
      borderRadius: '15px',
      maxWidth: '400px',
      width: '90%',
      textAlign: 'center',
    },
    modalTitle: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#123249',
      marginBottom: '10px',
    },
    modalProduct: {
      fontSize: '1rem',
      color: '#2D5A74',
      marginBottom: '10px',
    },
    modalPrice: {
      fontSize: '1.2rem',
      fontWeight: '600',
      color: '#447793',
      marginBottom: '20px',
    },
    whatsappOption: {
      width: '100%',
      padding: '15px',
      backgroundColor: '#25D366',
      color: 'white',
      border: 'none',
      borderRadius: '10px',
      fontSize: '1rem',
      fontWeight: '600',
      cursor: 'pointer',
      marginBottom: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.3s',
    },
    callOption: {
      width: '100%',
      padding: '15px',
      backgroundColor: '#1976D2',
      color: 'white',
      border: 'none',
      borderRadius: '10px',
      fontSize: '1rem',
      fontWeight: '600',
      cursor: 'pointer',
      marginBottom: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.3s',
    },
    closeOption: {
      width: '100%',
      padding: '10px',
      backgroundColor: 'transparent',
      color: '#123249',
      border: '1px solid #DDE8ED',
      borderRadius: '10px',
      fontSize: '0.95rem',
      cursor: 'pointer',
      transition: 'all 0.3s',
    },
  };

  return (
    <div style={styles.container}>
      {/* Options Modal */}
      {showOptions && (
        <div style={styles.modalOverlay} onClick={() => setShowOptions(false)}>
          <div style={styles.modal} onClick={e => e.stopPropagation()}>
            <h3 style={styles.modalTitle}>Contact Options</h3>
            <p style={styles.modalProduct}>{product.name}</p>
            <p style={styles.modalPrice}>Total: ₹{(product.price * quantity).toLocaleString()}</p>
            
            <button 
              style={styles.whatsappOption}
              onClick={handleWhatsAppOrder}
              onMouseEnter={(e) => e.target.style.background = '#128C7E'}
              onMouseLeave={(e) => e.target.style.background = '#25D366'}
            >
              <span style={{fontSize: '24px', marginRight: '10px'}}>📱</span>
              Order via WhatsApp
            </button>
            
            <button 
              style={styles.callOption}
              onClick={handleCallOrder}
              onMouseEnter={(e) => e.target.style.background = '#0D47A1'}
              onMouseLeave={(e) => e.target.style.background = '#1976D2'}
            >
              <span style={{fontSize: '24px', marginRight: '10px'}}>📞</span>
              Call to Order
            </button>
            
            <button 
              style={styles.closeOption}
              onClick={() => setShowOptions(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Back Button */}
      <button 
        style={styles.backButton}
        onMouseEnter={(e) => e.target.style.backgroundColor = '#2D5A74'}
        onMouseLeave={(e) => e.target.style.backgroundColor = '#447793'}
        onClick={() => navigate('/products')}
      >
        ← Back to Products
      </button>

      {/* Main Product Detail */}
      <div style={styles.productContainer}>
        {/* Left Side - Images */}
        <div style={styles.imageSection}>
          <div style={styles.mainImage}>
            {product.image ? (
              <img 
                src={product.image} 
                alt={product.name}
                style={styles.mainImageTag}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.style.display = 'none';
                  e.target.parentNode.innerHTML = `<div style="font-size:5rem;color:#123249">${getCategoryIcon(product.category)}</div>`;
                }}
              />
            ) : (
              <div style={styles.imagePlaceholder}>
                {getCategoryIcon(product.category)}
              </div>
            )}
          </div>
          
          <div style={styles.thumbnailContainer}>
            {(product.images || [product.image]).map((img, index) => (
              <div 
                key={index}
                style={{
                  ...styles.thumbnail,
                  border: selectedImage === index ? '2px solid #447793' : '1px solid #DDE8ED'
                }}
                onClick={() => setSelectedImage(index)}
                onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
              >
                {img ? (
                  <img 
                    src={img} 
                    alt={`${product.name} - ${index + 1}`}
                    style={styles.thumbnailImage}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.style.display = 'none';
                      e.target.parentNode.innerHTML = `<div style="font-size:1.5rem;color:#123249">${getCategoryIcon(product.category)}</div>`;
                    }}
                  />
                ) : (
                  <div style={styles.thumbnailPlaceholder}>
                    {getCategoryIcon(product.category)}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Right Side - Details */}
        <div style={styles.detailsSection}>
          {/* Title and Rating */}
          <h1 style={styles.productName}>{product.name}</h1>
          
          <div style={styles.ratingContainer}>
            <div style={styles.stars}>
              {"★".repeat(Math.floor(product.rating))}
              {"☆".repeat(5 - Math.floor(product.rating))}
            </div>
            <span style={styles.reviewCount}>({product.reviews} reviews)</span>
          </div>

          {/* Price Section */}
          <div style={styles.priceSection}>
            <span style={styles.currentPrice}>₹{product.price.toLocaleString()}</span>
            {product.originalPrice > product.price && (
              <>
                <span style={styles.originalPrice}>₹{product.originalPrice.toLocaleString()}</span>
                <span style={styles.discountBadge}>{discountPercentage}% OFF</span>
              </>
            )}
          </div>

          {/* Savings */}
          {product.originalPrice > product.price && (
            <div style={styles.savings}>
              You Save: ₹{(product.originalPrice - product.price).toLocaleString()}
            </div>
          )}

          {/* Availability */}
          <div style={styles.availability}>
            <span style={product.stock > 0 ? styles.inStock : styles.outOfStock}>
              {product.stock > 0 ? `✅ In Stock (${product.stock} available)` : '❌ Out of Stock'}
            </span>
          </div>

          {/* Short Description */}
          <p style={styles.description}>{product.description}</p>

          {/* Key Features */}
          <div style={styles.featuresSection}>
            <h3 style={styles.sectionTitle}>Key Features</h3>
            <ul style={styles.featuresList}>
              {product.features.map((feature, index) => (
                <li key={index} style={styles.featureItem}>✓ {feature}</li>
              ))}
            </ul>
          </div>

          {/* Quantity Selector */}
          <div style={styles.quantitySection}>
            <label style={styles.quantityLabel}>Quantity:</label>
            <div style={styles.quantityControl}>
              <button 
                style={styles.quantityBtn}
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#447793'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#DDE8ED'}
              >
                -
              </button>
              <input 
                type="number" 
                value={quantity}
                onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))}
                style={styles.quantityInput}
                min="1"
                max={product.stock}
              />
              <button 
                style={styles.quantityBtn}
                onClick={() => setQuantity(Math.min(product.stock, quantity + 1))}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#447793'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#DDE8ED'}
              >
                +
              </button>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={styles.actionButtons}>
            <button 
              style={styles.addToCartBtn}
              onClick={handleAddToCart}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2D5A74'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#447793'}
            >
              🛒 Add to Cart
            </button>
            <button 
              style={styles.buyNowBtn}
              onClick={handleBuyNow}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#123249'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#2D5A74'}
            >
              ⚡ Buy Now
            </button>
          </div>

          {/* Delivery Info */}
          <div style={styles.deliveryInfo}>
            <div style={styles.deliveryItem}>
              <span style={styles.deliveryIcon}>🚚</span>
              <span>Free Delivery</span>
            </div>
            <div style={styles.deliveryItem}>
              <span style={styles.deliveryIcon}>⚡</span>
              <span>Easy Returns</span>
            </div>
            <div style={styles.deliveryItem}>
              <span style={styles.deliveryIcon}>🔧</span>
              <span>Installation Available</span>
            </div>
          </div>

          {/* Full Description */}
          <div style={styles.fullDescription}>
            <h3 style={styles.sectionTitle}>Product Description</h3>
            <p style={styles.fullDescriptionText}>{product.fullDescription}</p>
          </div>

          {/* Specifications */}
          {product.specs && Object.keys(product.specs).length > 0 && (
            <div style={styles.specsSection}>
              <h3 style={styles.sectionTitle}>Specifications</h3>
              <table style={styles.specsTable}>
                <tbody>
                  {Object.entries(product.specs).map(([key, value]) => (
                    <tr key={key}>
                      <td style={styles.specKey}>{key.charAt(0).toUpperCase() + key.slice(1)}</td>
                      <td style={styles.specValue}>{value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;